import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Submotive1ActionsProps } from './props';
import { useSubmotive1ListActions } from './hook';

export const Submotive1ListActions = ({ id }: Submotive1ActionsProps) => {
    const { handleEdit } = useSubmotive1ListActions(id);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
